import * as amplitude from '@amplitude/analytics-browser';

const { REACT_APP_AMPLITUDE_API_KEY } = process.env;

amplitude.init(REACT_APP_AMPLITUDE_API_KEY ?? '', {
    defaultTracking: {
        pageViews: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: true,
    },
});

export default amplitude;
